import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { ContentComponent } from 'app/layout/components/content/content.component';

@NgModule({
  imports: [CommonModule, RouterModule, FuseSharedModule, ContentComponent],
  exports: [ContentComponent],
})
export class ContentModule {}
